import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M54.22 27.8818C53.36 19.1618 48.9 10.3218 41.8 7.85181C40.41 11.2118 37.93 21.2118 37.53 23.3218C37.7 23.2918 37.86 23.2518 38.03 23.2318C42.45 22.6818 45.91 25.0518 48.1 29.8418C52.13 38.6518 51.46 59.1218 51.46 59.1218C51.46 59.1218 55.28 38.6518 54.22 27.8818Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M31.5801 26.7518C25.9901 26.4318 22.24 23.7618 17.92 23.2318C13.5 22.6818 10.04 25.0518 7.85004 29.8418C3.82004 38.6518 4.49006 59.1218 4.49006 59.1218C4.49006 59.1218 0.670046 38.6618 1.73005 27.8918C2.65005 18.5218 7.63005 8.65184 15.8601 5.84184C22.4901 3.58184 25.9301 5.40184 30.0801 5.34184C33.4901 5.29184 35.6801 5.01185 35.3901 1.89185C35.3901 1.89185 37.8601 1.98185 38.7001 3.80185C39.5301 5.59185 38.42 7.10185 38.42 7.10185C38.42 7.10185 44.8001 4.95184 46.7601 7.93184C48.4201 10.4418 45.5801 15.0318 45.5801 15.0318C45.5801 15.0318 48.7001 16.4118 47.3701 19.8718C46.0801 23.2218 40.2001 27.2418 31.5801 26.7518Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M22.0701 24.5419C23.5801 24.6619 25.0801 24.5719 26.5301 24.3419C27.9701 24.0919 29.3701 23.6419 30.6201 22.9319C31.8701 22.2419 33.02 21.3219 33.91 20.1719C34.42 19.6419 34.7601 18.9819 35.2001 18.3819C35.6101 17.7619 35.89 17.0619 36.29 16.4019C36.1 17.1319 35.9101 17.8819 35.6401 18.6019C35.3001 19.2919 35.03 20.0319 34.54 20.6419C33.71 21.9719 32.47 23.0319 31.1 23.8119C29.72 24.5719 28.1701 25.0219 26.6201 25.1219C25.0701 25.2219 23.5101 25.0419 22.0701 24.5419Z"
        fill={outline}
      />
      <path
        d="M38.97 20.4719C38.68 21.4019 38.1501 22.2519 37.5201 23.0019C36.8901 23.7619 36.1201 24.4019 35.2701 24.9219C34.8501 25.1819 34.3801 25.3819 33.9301 25.5819C33.4501 25.7219 32.9901 25.9119 32.4901 25.9619C31.5201 26.1619 30.5101 26.0819 29.5701 25.8619C30.5301 25.6619 31.44 25.5219 32.3 25.2019C33.16 24.9119 33.9901 24.5419 34.7601 24.0619C36.3201 23.1519 37.67 21.9019 38.97 20.4719Z"
        fill={outline}
      />
    </g>
  )
}
